<template>
  <div class="pb-12 mt-n2 poppins" style="background: #f7f7fa">
    <div class="px-1 px-md-4 mb-2 justify-content-center">
      <div class="d-flex align-items-center px-7">
        <div class="row justify-content-between">
          <div class="col-12">
            <h3 class="font-weight-bolder mb-1">Performance Dashboard</h3>
            <p class="text-dark-50 font-weight-bold">Home - Dashboards</p>
          </div>
        </div>
        <DashboardWarehouseSelect :updateData="loadInitialDataFromServer" />
      </div>
    </div>

    <DashboardPerformanceGroup :serverData="serverData" />
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import DashboardPerformanceGroup from "@/own/components/dashboard/DashboardPerformanceGroupNew.vue";
import DashboardWarehouseSelect from "@/own/components/dashboard/DashboardWarehouseSelect.vue";
import {
  SET_WAREHOUSE,
  SET_WAREHOUSES_LIST,
} from "@/core/services/store/auth.module";

export default {
  name: "DashboardPerformance",
  components: { DashboardPerformanceGroup, DashboardWarehouseSelect },
  data: () => ({
    serverData: [],
    refreshDataIntervalId: null,
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.loadInitialDataFromServer();
    this.startAutoRefresh();
  },
  beforeDestroy() {
    this.stopIntervals();
  },
  methods: {
    startAutoRefresh() {
      this.refreshDataIntervalId = setInterval(() => {
        this.loadInitialDataFromServer(
          true,
          this.$store.getters.getSelectedWarehouse
        );
      }, 300000);
    },
    stopIntervals() {
      clearInterval(this.refreshDataIntervalId);
    },
    loadInitialDataFromServer(forAutoRefresh = false, param = null) {
      this.$store.commit(SET_PAGE_LOADING, true);
      let filterData = {
        date_range_type: "custom",
        date_range: ["2021-01-15", "2021-02-14"],
      };

      let url = param
        ? `/dashboards/dashboardPerformance?warehouse_id=${param}`
        : "/dashboards/dashboardPerformance";

      ApiService.post(url, filterData)
        .then((response) => {
          // console.log(response.data);
          // this.serverData = response.data;

          this.serverData = response.data.data[0];

          if (!forAutoRefresh) {
            this.$store.commit(
              SET_WAREHOUSE,
              response.data.selected_warehouse_id
            );
            this.$store.commit(SET_WAREHOUSES_LIST, response.data.warehouses);
          }
          // this.$store.commit(SET_PAGE_LOADING, false);
        })
        .catch((error) => {
          // this.$store.commit(SET_PAGE_LOADING, false);
        })
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
  },
};
</script>
